module.exports = __webpack_public_path__ + "img/logo-sfg-b-600.9471ada1.png";